import { Platform } from "react-native"; // นำเข้า Platform เพื่อเช็คว่าเป็น Web
import { apikey, apirouter } from "../../api/apirouter";
import apiurl from "../../api/apiurl";

export const actiontype = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  GET_ROLE: "GET_ROLE",
  AUTHEN: "AUTHEN",
  GET_PROFILE: "GET_PROFILE",
};

apiurl.defaults.withCredentials = true;

export const login = (empcode: any) => async (dispatch: any) => {
  try {
    const res = await apiurl.post(
      apirouter.login,
      {
        empcode: empcode.toUpperCase(),
      },
      {
        headers: {
          "x-api-key": apikey,
        },
      }
    );
    
    if (res.status === 200) {
      dispatch({
        type: actiontype.LOGIN,
        payload: res.data,
      });
      return { success: true, data: res.data };
    } else {
      console.log("error");
      return { success: false, message: "Login Failed" };
    }
  } catch (error: any) {
    return { success: false, message: error.response.data.message };
  }
};

export const getProfile = (token: any) => async (dispatch: any) => {
  try {
    const res = await apiurl.get(apirouter.profile, {
      headers:  {
        "Authorization": `Bearer ${token}`,
      },
    });
    
    dispatch({
      type: actiontype.GET_PROFILE,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
  }
}

export const logout = () => async (dispatch: any) => {
  // [เพิ่มโค้ดส่วนนี้] เคลียร์ Session ทุกอย่างทิ้งเมื่อมีการเรียกฟังก์ชัน logout
  if (Platform.OS === "web") {
    localStorage.removeItem("empcode");
    localStorage.removeItem("sessionExpiry");
    localStorage.removeItem("userToken"); 
    localStorage.removeItem("userData");
  }

  dispatch({
    type: actiontype.LOGOUT,
  });

  return { success: true };
}

export default {
  login,
  getProfile,
  logout, // ส่งออก logout ด้วยเผื่อเรียกใช้แบบ object
};